import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// import { ToolbarService,  LinkService,  ImageService,  HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-item-comment',
  templateUrl: './invoice-item-comment.component.html',
  // providers: [ ToolbarService, LinkService, ImageService, HtmlEditorService ],
  styleUrls: ['./invoice-item-comment.component.css']
})
export class InvoiceItemCommentComponent implements OnInit {

  model = { 'sub_item_name': '', 'sub_item_no': '', 'comment': '' };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<InvoiceItemCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

  }

  ngOnInit() {

    if (this.dialog_data != null) {
      this.model['sub_item_name'] = this.dialog_data['sub_item_name'];
      this.model['sub_item_no'] = this.dialog_data['sub_item_no'];
      this.model['comment'] = this.dialog_data['comment'];
    }
  }

  add() {
    this.dialog_data = {
      'sub_item_name': this.model['sub_item_name'],
      'sub_item_no': this.model['sub_item_no'], 'comment': this.model['comment'],
      'op_type': 'success'
    }

    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
